import React from 'react';
import { useFormikContext } from 'formik'
import styled from 'styled-components';
import { TextField, FileSelect } from 'components/forms';
import { useApplication } from 'lib/application-provider';
import { formatEIN } from 'lib/util/formatters';
import { H1 } from 'components/text';

const Hint = styled.div`
  margin-top: -${props => props.theme.paddingS};
  margin-bottom: ${props => props.theme.paddingS};
  color: ${props => props.theme.primaryText};
  font-size: ${props => props.theme.fontSizeXS};
  ul {
    list-style: none;
    
    li {
      margin-bottom: 0;
      line-height: ${props => props.theme.lineHeightS};
    }
  }
`

const Docs = () => {
  const { values, setFieldValue } = useFormikContext();
  const application = useApplication();
  
  return (
    <>
      <H1>Supporting Documents</H1>
      <FileSelect
        name="entity.certificate_of_good_standing"
        label="Certificate of good standing"
        onChange={async (byteArray) => await application.upload('certificate_of_good_standing', byteArray)}
      />
      <Hint>Needs to be dated within the past year.</Hint>
      
      <FileSelect
        name="entity.organization_documents"
        label="Organizational documents"
        onChange={async (byteArray) => await application.upload('organization_documents', byteArray)}
      />
      <Hint>
        <strong>One</strong> of the following:
        <ul>
          <li>&#8226; Certificate of Incorporation and Bylaws</li> 
          <li>&#8226; Partnership Agreement and Registration Certificate</li> 
          <li>&#8226; LLC Operating Agreement and Registration Certificate</li>
          <li>&#8226; Other organizational documents</li>
        </ul>
      </Hint>
      
      <FileSelect
        name="entity.aml_policy"
        label="AML Policy"
        onChange={async (byteArray) => await application.upload('aml_policy', byteArray)}
      />
      
      <TextField
        name="entity.legal_entity_identifier"
        label="Legal entity identifier (LEI)"
        required
      />
      <Hint>Get one at <a href="https://lei.bloomberg.com" target="_blank" rel="noopener noreferrer">lei.bloomberg.com</a>.</Hint>

      {values && values.entity && values.entity.address && values.entity.address.country === 'US' &&
        <TextField
          name="entity.ein"
          label="Employer identification number (EIN)"
          required
          onChange={(e) => setFieldValue('entity.ein', formatEIN(e.target.value))}
          className="fs-block"  // exclude from fullstory
        />
      }
    </>
  );
}

export default Docs;
